import { render, staticRenderFns } from "./noUseFreePopup.vue?vue&type=template&id=2be1b460&scoped=true"
import script from "./noUseFreePopup.vue?vue&type=script&lang=js"
export * from "./noUseFreePopup.vue?vue&type=script&lang=js"
import style0 from "./noUseFreePopup.vue?vue&type=style&index=0&id=2be1b460&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be1b460",
  null
  
)

export default component.exports